import { Inject, Injectable } from '@angular/core';
import { FormControl, FormControlStatus, FormGroup, Validators } from '@angular/forms';
import { USER_CONFIG, UserConfig } from '@core/modules/user/user.config';
import { DeviceUserFormControlName } from '../models';
import { MyDevicesFormState } from '../types/my-devices-form-builder-service.type';

@Injectable({
  providedIn: 'any'
})
export class DeviceBlockService {
  constructor(@Inject(USER_CONFIG) private readonly config: UserConfig) {}

  resetSubmittedWhenPassphraseError(
    myDevicesFormState: MyDevicesFormState,
    passphraseControl: FormControl
  ): void {
    if (passphraseControl && passphraseControl.errors) {
      myDevicesFormState.isSubmitting = false;
    }
  }

  onChangedSerial(
    form: FormGroup,
    myDevicesFormState: MyDevicesFormState,
    serialFormControl: FormControl,
    value: string
  ): void {
    myDevicesFormState.isSubmitting = false;
    serialFormControl.reset(value);
    form.markAsDirty();
  }

  onUseSharedDevice(
    form: FormGroup,
    myDevicesFormState: MyDevicesFormState,
    deviceFormGroupControl: FormGroup,
    useSharedDevice: boolean
  ): void {
    myDevicesFormState.isSubmitting = false;
    form.markAsDirty();

    if (useSharedDevice) {
      deviceFormGroupControl.addControl(
        DeviceUserFormControlName.PASSPHRASE,
        new FormControl(null, Validators.required)
      );
      return;
    }

    deviceFormGroupControl.removeControl(DeviceUserFormControlName.PASSPHRASE);
  }

  isSubmittedSerialControl(serialFormControl: FormControl) {
    return (
      !serialFormControl.pristine &&
      !serialFormControl.hasError('pending') &&
      !(['DISABLED', 'PENDING'] as FormControlStatus[]).includes(serialFormControl.status)
    );
  }

  isSubmittedPassphraseControl(passphraseFormControl: FormControl) {
    return (
      passphraseFormControl &&
      !passphraseFormControl.pristine &&
      !(['DISABLED', 'PENDING'] as FormControlStatus[]).includes(passphraseFormControl.status)
    );
  }

  // ERROR

  isShowProblemFormFor(serialControl: FormControl) {
    const requiredErrorCode = 'required';
    const control = serialControl;

    if (control.disabled) return false;
    if (control.hasError(requiredErrorCode)) return false;

    return !!Object.keys(control.errors ?? {}).filter(
      (error) => ![requiredErrorCode, 'pending'].includes(error)
    ).length;
  }

  loadFeedbackErrorLists() {
    return {
      serial: {
        ...this.config.ERRORS.REQUIRED_FIELD,
        ...this.config.ERRORS.INVALID_SERIAL,
        ...this.config.ERRORS.NOT_FREE_SERIAL,
        ...this.config.ERRORS.DISABLED_SERIAL,
        ...this.config.ERRORS.SMALL_SERIAL,
        ...this.config.ERRORS.INCORRECT_SERIAL_PASSPHRASE
      },
      passphrase: {
        ...this.config.ERRORS.REQUIRED_FIELD
      }
    };
  }
}
